import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    origin_zone_id: data?.origin_zone?.id,
    destination_zone_id: data?.destination_zone?.id,
    city_id: data?.city?.id
  }
};
export const structure = (options, cityId, t) => [
    {
      head: "",
      width: "100%",
      list: [
        {
          name: `city_id`,
          kind: "select",
          type: "text",
          label: t ? `${t("common.city")}*` : "City name*",
          width: "47%",
          placeholder: t ? t("cities.write_city_name") : "Write the city name",
          ...options?.cities
          // onChange: (value) => handleCityChange(value)
        },
        {
          name: `origin_zone_id`,
          kind: "select",
          type: "text",
          label: t ? `${t("between_zones_fees.origin_zone")}*` : "Origin zone*",
          width: "47%",
          placeholder: t ? t("cities.write_city_name") : "Write the city name",
          ...options?.zones,
          disabled: !cityId
        },
        {
          name: `destination_zone_id`,
          kind: "select",
          type: "text",
          label: t ? `${t("between_zones_fees.destination_zone")}*` : "Destination zone*",
          width: "47%",
          placeholder: t ? t("cities.write_city_name") : "Write the city name",
          ...options?.zones,
          disabled: !cityId
        },
        {
          name: `delivery_fees`,
          kind: "input",
          type: "text",
          label: t ? `${t("between_zones_fees.delivery_fees")}*` : "Delivery fees*",
          width: "47%",
          EndAdornment: (
            <p style={{ fontSize: '18px', color: "#1A1A1A" }} >SAR</p>
          ),
          placeholder: t ? t("zones.write_delivery_fees") : "Write Delivery fees"
        },

      ],
    },
  ];

export const validationSchema = (t) =>
  Yup.object({
    city_id: Yup.string().required(t ? t("vendors.error_required") : "required"),
    origin_zone_id: Yup.string().required(t ? t("vendors.error_required") : "required"),
    destination_zone_id: Yup.string().required(t ? t("vendors.error_required") : "required"),
    delivery_fees: Yup.number(t ? t("vendors.error_required") : "please enter a valid number").required(t ? t("vendors.error_required") : "required"),
  });
